import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const IDVModalWrapper = styled.div`
  width: 100%;
  margin-top: -25px;
  @media (min-width: 768px) {
    margin-top: 0px;
  }
`;

export const IDVModalHeading = styled(Text)`
    color: var(--text-primary-n-600, #040222);
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; 
    letter-spacing: -0.1px;
    margin-bottom: 8px;
`;

export const IDVModalSubHeading = styled(Text)`
    color: var(--Neutral-N500, #36354C);
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    margin-bottom: 24px;
`;

export const IdvInfoCard = styled.div`
  display: inline-flex;
  padding: 10px;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  border: 1px solid var(--Purple-P50, #efe9fb);
  background: #f9f6ff;
  color: var(--Neutral-N500, #36354c);

  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 32px;
`;

export const IDVPrice = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid var(--line-secondary-n-300, #e0e0e8);
  background: var(--background-white-n-0, #fff);
  width: fit-content;
  margin-bottom: 40px;
`;

export const IDVPriceValue = styled.input`
  color: var(--Purple-P400, #5920c5);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
  border: none;
  outline: none;
  width: 50px;
  margin-left: -4px
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const IDVPriceText = styled.span`
  color: var(--Purple-P400, #5920c5);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
`;

export const IDVUnitValue = styled(Text)`
  color: var(--text-secondary-n-400, #5b5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const IDVCta = styled.button`
  display: flex;
  width: 100%;
  height: 48px;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: var(--button-default-g-300, #0fa457);
  margin-top: 48px;
  border: none;
  cursor: pointer;
  color: var(--Surface-White, #fff);
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0.1px;
`;

export const IDVErrorText = styled(Text)`
  color: var(--button-error-r-400, #d83d37);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;